import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

import { API_URL } from "../../../../constants";
import { GetServiceCaller } from "../../../../services/serviceCaller";

export const OrgChartTreeHandler = () => async (dispatch) => {
  dispatch(setFetchingOrgChartTree(true));
  try {
    const response = await GetServiceCaller(
      `${API_URL}org-report/2`
    );
    console.log("checkResponse:::::", response);
    if (response?.data) {
      dispatch(setOrgChartTreeData(response?.data));
    } else {
      dispatch(setOrgChartTreeError("No Data Found"));
    }
  } catch (error) {
    dispatch(setOrgChartTreeError(error.message));
  } finally {
    dispatch(setFetchingOrgChartTree(false));
  }
};

const initialState = {
  apiStatus: 0,
  fetching: false,
  data: [],
  errors: "",
};

const orgChartTreeSlice = createSlice({
  name: "organization",
  initialState,
  reducers: {
    setOrgChartTreeData: (state, action) => {
      state.apiStatus += 1;
      state.data = action.payload;
      state.errors = "";
    },
    setFetchingOrgChartTree: (state, action) => {
      state.fetching = action.payload;
    },
    setOrgChartTreeError: (state, action) => {
      state.apiStatus += 1;
      state.data = [];
      state.errors = action.payload;
    },
  },
});

export const {
  setOrgChartTreeData,
  setFetchingOrgChartTree,
  setOrgChartTreeError,
} = orgChartTreeSlice.actions;

export default orgChartTreeSlice.reducer;
